// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Game_wrapper__7GH7v","main":"Game_main__OVMCI","timer":"Game_timer__21Pkh","progress":"Game_progress__r6qge"};